import { render } from "./CustomTextControl.vue?vue&type=template&id=ffa34b2e&ts=true"
import script from "./CustomTextControl.vue?vue&type=script&lang=ts"
export * from "./CustomTextControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/workflow/infrastructure/component/rete/customization/CustomTextControl.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ffa34b2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ffa34b2e', __exports__)) {
    api.reload('ffa34b2e', __exports__)
  }
  
  module.hot.accept("./CustomTextControl.vue?vue&type=template&id=ffa34b2e&ts=true", () => {
    api.rerender('ffa34b2e', render)
  })

}


export default __exports__